import dateFormat from "date-fns/format";
import { Column, CouponDetails } from "src/api/types";

export const columns: readonly Column<CouponDetails>[] = [
  {
    id: "product_name",
    label: "Product",
    minWidth: 50,
    align: "center",
    format: (value) => String(value.product_name),
    orderable: false,
  },
  {
    id: "amount",
    label: "Discount",
    minWidth: 80,
    align: "center",
    format: (value) => `$${value.amount} Off`,
    orderable: true,
    orderBy: "amount",
  },
  {
    id: "name",
    label: "Code name",
    minWidth: 50,
    align: "center",
    format: (value) => value.name,
    orderable: false,
  },
  {
    id: "created_at",
    label: "Date Uploaded",
    minWidth: 50,
    align: "center",
    format: (value) =>
      dateFormat(new Date(value.created_at || ""), "MM/dd/yyyy"),
    orderable: true,
    orderBy: "created_at",
  },
  {
    id: "active",
    label: "Status",
    minWidth: 50,
    align: "center",
    format: (value) => String(value.is_active).toUpperCase(),
    orderable: false,
  },
  {
    id: "redemptions",
    label: "Redemptions",
    minWidth: 50,
    align: "center",
    format: (value) => value.redeemed.toString(),
    orderable: true,
    orderBy: "redeemed",
    default_sort: "redeemed",
  },
];
